export * from './auditResource.service';
import { AuditResourceService } from './auditResource.service';
export * from './eventsPositionResource.service';
import { EventsPositionResourceService } from './eventsPositionResource.service';
export * from './migrationSchedules.service';
import { MigrationSchedulesService } from './migrationSchedules.service';
export * from './paymentsConfirmationResource.service';
import { PaymentsConfirmationResourceService } from './paymentsConfirmationResource.service';
export const APIS = [AuditResourceService, EventsPositionResourceService, MigrationSchedulesService, PaymentsConfirmationResourceService];
